import { render, staticRenderFns } from "./changeDeptModal.vue?vue&type=template&id=15f8eba8&scoped=true"
import script from "./changeDeptModal.vue?vue&type=script&lang=js"
export * from "./changeDeptModal.vue?vue&type=script&lang=js"
import style0 from "./changeDeptModal.vue?vue&type=style&index=0&id=15f8eba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8eba8",
  null
  
)

export default component.exports